export const getUngroupedItems = (items: any[]): any[] => {
  if (!Array.isArray(items)) return [] // Ensure items is an array

  return items.flatMap(item =>
    item?.type === 'group' && Array.isArray(item?.children) ? item?.children : item
  )
}
